class PermissionsService {
  public static instance = new PermissionsService();
  public userPermissions?: string[];
}

export default PermissionsService.instance;
